import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { mapAutoZoom } from "../../../actions/map";
import { setAppState } from "../../../helpers/session";
import StateProvider from "./StateProvider";
import "../../../../assets/scss/map-control.scss";

const mapDispacthToProps = dispatch => ({
    actions: bindActionCreators({ mapAutoZoom }, dispatch)
});

const mapStateToProps = state =>
    ({ isAutoZoom: state.map.isAutoZoom });

const AutoZoomToggleControl = connect(mapStateToProps, mapDispacthToProps)(props => {
    return <div
        title={`Auto Zoom ${props.isAutoZoom ? "OFF" : "ON"}`}
        className={`square-control auto-zoom ${props.isAutoZoom && "active"}`}
        onClick={() => {
            setAppState({ isAutoZoom: !props.isAutoZoom });
            props.actions.mapAutoZoom(!props.isAutoZoom);
        }}
    >
        <i className={`icon ${props.isAutoZoom ? "icon-focus" : "icon-unfocus"}`} />
    </div>;
});

export default () =>
    (<StateProvider>
        <AutoZoomToggleControl />
    </StateProvider>);